export default {
	SET_ERROR_STATUS: '@@base/SET_ERROR_STATUS',
	SHOW_SIGN_MODAL: '@@base/TOGGLE_SIGN_MODAL',
	EDIT: '@@base/EDIT'
}
